var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddMember(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#F7F9FB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5060_10594)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7326 24.338V22.5352C20.7326 21.5789 20.3527 20.6618 19.6765 19.9856C19.0003 19.3094 18.0832 18.9296 17.1269 18.9296H10.8171C9.86079 18.9296 8.94368 19.3094 8.26749 19.9856C7.5913 20.6618 7.21143 21.5789 7.21143 22.5352V24.338",
    stroke: "#7E7E7E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9718 15.3239C15.9632 15.3239 17.5775 13.7096 17.5775 11.7183C17.5775 9.72697 15.9632 8.11267 13.9718 8.11267C11.9805 8.11267 10.3662 9.72697 10.3662 11.7183C10.3662 13.7096 11.9805 15.3239 13.9718 15.3239Z",
    stroke: "#7E7E7E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3384 12.6198V18.0282",
    stroke: "#7E7E7E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0422 15.324H21.6338",
    stroke: "#7E7E7E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5060_10594"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.6338,
    height: 21.6338,
    fill: "white",
    transform: "translate(6.31006 5.40845)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddMember);
export default __webpack_public_path__ + "static/media/add-member.4199f4ea40ba9eb8986a4d42a4b1e23c.svg";
export { ForwardRef as ReactComponent };